import type { StorefrontItem } from './types';

export function adaptStorefrontItem(raw: unknown): StorefrontItem {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<StorefrontItem>;
  return {
    id: String(data.id || ''),
    name: String(data.name || 'Coaching Item'),
    amountMinor: Number(data.amountMinor || 0),
    currency: String(data.currency || 'INR'),
    description: String(data.description || ''),
  };
}

export function adaptStorefrontItemList(raw: unknown): StorefrontItem[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptStorefrontItem);
}
